import snapshot from './developmentFirestoreCompetitorSample.v0.1.json';
import { accountForCapturedAnswers } from './capturedAnswerCompatibility';
import type { AdvisoryBriefDocumentInputV01 } from './types';

/**
 * Metadata for the completed development run captured in the adjacent JSON
 * fixture. The browser never reads another user's Firestore path at runtime.
 */
export const DEVELOPMENT_FIRESTORE_COMPETITOR_SAMPLE_SOURCE = snapshot.source;

/**
 * Two in-progress backend answers whose canonical questions also belong to
 * Competitor Analysis, kept in the source key-question read order.
 */
export const DEVELOPMENT_FIRESTORE_COMPETITOR_SAMPLE = accountForCapturedAnswers(
  snapshot.document as unknown as AdvisoryBriefDocumentInputV01
);
